/**
 * Representa a origem de abertura do menu suspenso.
 */
enum DropdownMenuOrigin {
  TopRight = "top-right",
  TopRightPartial = "top-right-partial",
  TopLeft = "top-left",
  TopLeftPartial = "top-left-partial",
  TopStart = "top-start",
  TopStartPartial = "top-start-partial",
  TopEnd = "top-end",
  TopEndPartial = "top-end-partial",
  BottomRight = "bottom-right",
  BottomRightPartial = "bottom-right-partial",
  BottomLeft = "bottom-left",
  BottomLeftPartial = "bottom-left-partial",
  BottomStart = "bottom-start",
  BottomStartPartial = "bottom-start-partial",
  BottomEnd = "bottom-end",
  BottomEndPartial = "bottom-end-partial"
}
